const STRING = Object.freeze({
  // special cases, try to keep them in alphabetic order
  empty: '',
  newline: '\n',
  replacementCharacter: String.fromCodePoint(0xfffd), // �

  // named regular keyboard symbols, try to keep them in alphabetic order
  colon: ':',
  hash: '#',
  minus: '-',
  percent: '%',
  plus: '+',
  plusPurple: '➕',
  space: ' ',
  underscore: '_',
  zero: '0',

  // for punctuation, try to keep them in alphabetic order
  ndash: String.fromCodePoint(8211), // NOTE: shorter dash;
  mdash: String.fromCodePoint(8212), // NOTE: longer dash;
  quoteOpen: '‘',
  quoteClose: '’',
  quote: '"',

  // for HTML entities, try to keep them in alphabetic order
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  nbsp: '\xa0', // non-breaking space

  // currencies, try to keep them in alphabetic order
  dirham: 'د.إ', // NOTE: string inside is right-to-left
  dollar: '$',
  euro: '€',
  pound: '£',

  // arrow emojis, try to keep them in alphabetic order
  arrowE: '➡️',
  arrowEW: '↔️',
  arrowN: '⬆️',
  arrowNS: '↕️',
  arrowS: '⬇️',
  arrowW: '⬅️',
  arrowUpR: '↗️',
  arrowCounterclockwise: '🔄',
  arrowCurvedLeft: '↩️',
  arrowRepeating: '🔁',

  // backhand index emojis, try to keep them in alphabetic order
  indexDown: '👇',
  indexLeft: '👈',
  indexRight: '👉',
  indexUp: '👆',

  // hands
  dislike: '👎',
  like: '👍',
  raisedHands: '🙌',
  wavingHand: '👋',

  // color emojis
  circleBlack: '⚫️',
  circleBlue: '🔵',
  circleBrown: '🟤',
  circleGreen: '🟢',
  circleOrange: '🟠',
  circlePurple: '🟣',
  circleRed: '🔴',
  circleWhite: '⚪️',
  circleYellow: '🟡',

  squareBlack: '⬛️',
  squareBlue: '🟦',
  squareBrown: '🟫',
  squareGreen: '🟩',
  squareOrange: '🟧',
  squarePurple: '🟪',
  squareRed: '🟥',
  squareWhite: '⬜️',
  squareYellow: '🟨',

  // mixed emojis, try to keep them in alphabetic order
  barChart: '📊',
  bomb: '💣',
  crossMark: '❌',
  clock: '🕣',
  college: '👩',
  creditCard: '💳',
  chartIncreasing: '📈',
  deliveryTruck: '🚚',
  duck: '🦆',
  envelope: '✉️',
  email: '📧',
  faceWithTear: '🥲',
  fist: '💪',
  gear: '⚙️',
  heart: '🤍',
  heartSlick: '💜',
  info: 'ℹ️',
  lamp: '💡',
  ledger: '📒',
  eyes: '👀',
  key: '🔑',
  locked: ' 🔒 ',
  markVGreen: '✅',
  megaphone: '📣',
  mobilePhone: '📱',
  moneyBag: '💰',
  moneyWithWings: '💸',
  noEntry: '⛔',
  party: '🎉',
  phoneReceiver: '📞',
  poundBanknote: '💷',
  palm: '🌴',
  pin: '📍',
  questionMark: '❓',
  recycle: '♻',
  redFlag: '🚩',
  restricted: '🚫',
  rocket: '🚀',
  shuffle: '🔀',
  repeatButton: '🔁',
  star: '⭐️',
  sandwich: '🥪',
  speechBalloon: '💬',
  trash: '🗑️',
  trafficLightHorizontal: '🚥',
  trafficLightVertical: '🚦',
  trophy: '🏆',
  userLogin: '🧑‍💻', // this is combination of two emoji
  waitTriangle: '⚠️',
  wrappedGift: '🎁',

  // faces
  nerdFace: '🤓',
  partyingFace: '🥳',
  thinking: '🤔',
  shocked: '😱',
  smile: '😊',

  // people
  womanTechnologist: '👩‍💻',
  womanTipping: '💁‍♀️',
  womanGesturingNo: '🙅‍♀️',
  womanGetting: '💇‍♀️',
  womanRaisingHand: '🙋‍♀️',

  // other symbols, try to keep them in alphabetic order
  checkmark: '✓', // NOTE: Unicode Character “✓” (U+2713)
  markX: '✖',
  markV: '✔',
  passdot: '●', // NOTE: Unicode String.fromCodePoint(9679) or String.fromCharCode(9679)
  dot: '•',
  times: 'x',
});

export default STRING;
